import { Box } from '@fullstory/components';
import { classNames } from '@fullstory/util/fmt';
import React from 'react';
import css from './ProgressBar.module.scss';
import { decimalToPercent } from './utils';

export type ProgressBarProps = {
  // a value between 0 (inclusive) and 1 (inclusive)
  value: number;
};
export const ProgressBar: React.FunctionComponent<ProgressBarProps> = ({ value }) => (
  <Box data-component="ProgressBar" width="100%">
    <div className={classNames(css.barWrapper, css.barBackground)}>
      <div
        data-testid="progress"
        className={classNames(css.progress)}
        style={{
          width: decimalToPercent(value),
        }}
      />
    </div>
  </Box>
);
